import script from "./PagePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./PagePicker.vue?vue&type=script&setup=true&lang=js"

import "./PagePicker.vue?vue&type=style&index=0&id=718fb2eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-718fb2eb"]])

export default __exports__